/* Silverbloom Paris — Fiche produit — compatible éditeur de thème (ré-init sur shopify:section:load) */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  function fmt(cents) {
    var v = cents / 100;
    var s = v % 1 === 0 ? String(v) : v.toFixed(2).replace('.', ',');
    return s + ' €';
  }
  function read(key) { try { return JSON.parse(localStorage.getItem(key)) || []; } catch (e) { return []; } }
  function write(key, val) { try { localStorage.setItem(key, JSON.stringify(val)); } catch (e) {} }

  var WISH_KEY = 'silverbloom_wishlist';
  function syncHearts() {
    var list = read(WISH_KEY);
    $$('[data-sb-wish]').forEach(function (b) {
      b.classList.toggle('is-active', list.indexOf(b.getAttribute('data-sb-wish')) !== -1);
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-sb-wish]') : null;
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var h = btn.getAttribute('data-sb-wish');
    var list = read(WISH_KEY);
    var i = list.indexOf(h);
    if (i === -1) list.push(h); else list.splice(i, 1);
    write(WISH_KEY, list);
    syncHearts();
  });

  function initProduct(scope) {
    var root = (scope || document).querySelector('[data-sb-product]');
    if (!root || root.dataset.sbBound) return;
    root.dataset.sbBound = '1';

    var variants = [];
    try { variants = JSON.parse($('[data-sb-variants]', root).textContent); } catch (e) {}
    var groups = $$('[data-sb-option]', root);
    var msg = $('[data-sb-msg]', root);

    function selection() {
      return groups.map(function (g) {
        var b = $('.is-active[data-value]', g);
        return b ? b.getAttribute('data-value') : null;
      });
    }
    function match(sel) {
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < sel.length; j++) {
          if (sel[j] !== null && variants[i].options[j] !== sel[j]) { ok = false; break; }
        }
        if (ok) return variants[i];
      }
      return null;
    }
    function update() {
      var sel = selection();
      var complete = sel.every(function (x) { return x !== null; });
      var v = match(sel) || variants[0];
      if (v) {
        var p = $('[data-sb-price]', root); if (p) p.textContent = fmt(v.price);
        var i3 = $('[data-sb-installments]', root); if (i3) i3.textContent = fmt(Math.round(v.price / 3));
        var pb = $('[data-sb-price-btn]', root); if (pb) pb.textContent = fmt(v.price);
        var ps = $('[data-sb-price-sticky]', root); if (ps) ps.textContent = fmt(v.price);
        if (complete) { var idi = $('[data-sb-id]', root); if (idi) idi.value = v.id; }
      }
      groups.forEach(function (g) {
        var b = $('.is-active[data-value]', g);
        var lab = $('[data-sb-optvalue]', g);
        if (lab) lab.textContent = b ? b.getAttribute('data-value') : (g.getAttribute('data-empty-label') || '');
        var desc = $('[data-sb-optdesc]', g);
        if (desc) desc.textContent = b ? (b.getAttribute('data-desc') || '') : '';
      });
      var sub = $('[data-sb-subtitle]', root);
      if (sub) {
        var parts = [];
        groups.forEach(function (g) {
          if (g.getAttribute('data-kind') === 'size') return;
          var b = $('.is-active[data-value]', g);
          if (b) parts.push(b.getAttribute('data-value'));
        });
        if (parts.length) sub.textContent = parts.join(', ');
      }
    }
    groups.forEach(function (g) {
      $$('[data-value]', g).forEach(function (btn) {
        btn.addEventListener('click', function () {
          $$('[data-value]', g).forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          if (msg) msg.hidden = true;
          update();
        });
      });
    });
    var form = $('#sb-product-form', root) || $('form[action*="/cart/add"]', root);
    if (form) {
      form.addEventListener('submit', function (e) {
        var missing = groups.some(function (g) {
          return g.hasAttribute('data-choice-required') && !$('.is-active[data-value]', g);
        });
        if (missing) {
          e.preventDefault();
          if (msg) { msg.hidden = false; msg.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        }
      });
    }
    var del = $('[data-sb-delivery]', root);
    if (del) {
      var d = new Date(); var added = 0;
      while (added < 10) { d.setDate(d.getDate() + 1); var wd = d.getDay(); if (wd !== 0 && wd !== 6) added++; }
      del.textContent = d.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
    }
    update();

    var gal = $('[data-sb-gallery]', root);
    var thumbsWrap = $('[data-sb-thumbs]', root);
    function stride() {
      var slides = $$('.sb-pdp__media', gal);
      if (slides.length > 1) return slides[1].offsetLeft - slides[0].offsetLeft;
      return gal.clientWidth || 1;
    }
    if (gal && thumbsWrap) {
      var thumbs = $$('[data-sb-thumb]', thumbsWrap);
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var i = parseInt(t.getAttribute('data-sb-thumb'), 10);
          gal.scrollTo({ left: i * stride(), behavior: 'smooth' });
        });
      });
      var galTick = false;
      gal.addEventListener('scroll', function () {
        if (galTick) return;
        galTick = true;
        requestAnimationFrame(function () {
          var idx = Math.round(gal.scrollLeft / stride());
          thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
          var active = thumbs[idx];
          if (active && active.scrollIntoView) active.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
          galTick = false;
        });
      }, { passive: true });
    }

    var lightbox = $('[data-sb-lightbox]', root);
    if (lightbox && gal) {
      var lbImg = $('[data-sb-lightbox-img]', lightbox);
      var lbScroll = $('[data-sb-lightbox-scroll]', lightbox);
      var lbLast = null;
      var lbClose = function () {
        lightbox.hidden = true;
        lightbox.classList.remove('is-zoomed');
        lbImg.removeAttribute('src');
        document.removeEventListener('keydown', lbKey);
        if (lbLast) lbLast.focus();
      };
      var lbKey = function (e) { if (e.key === 'Escape') lbClose(); };
      $$('.sb-pdp__media[data-sb-zoom]', gal).forEach(function (slide) {
        slide.addEventListener('click', function () {
          if (!window.matchMedia('(max-width: 767px)').matches) return;
          lbLast = slide;
          lbImg.src = slide.getAttribute('data-sb-zoom');
          lightbox.hidden = false;
          document.addEventListener('keydown', lbKey);
        });
      });
      lbImg.addEventListener('click', function () {
        lightbox.classList.toggle('is-zoomed');
        if (!lightbox.classList.contains('is-zoomed')) { lbScroll.scrollTo(0, 0); }
      });
      $('[data-sb-lightbox-close]', lightbox).addEventListener('click', lbClose);
      lightbox.addEventListener('click', function (e) { if (e.target === lightbox) lbClose(); });
    }

    var sticky = $('[data-sb-sticky]', root);
    var mainAtc = $('[data-sb-atc]', root);
    if (sticky && mainAtc && 'IntersectionObserver' in window) {
      var stickyBtn = $('[data-sb-sticky-btn]', sticky);
      if (stickyBtn && form) {
        stickyBtn.addEventListener('click', function () {
          if (form.requestSubmit) form.requestSubmit(); else form.submit();
        });
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          sticky.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
        });
      }, { threshold: 0 });
      io.observe(mainAtc);
    }

    var accs = $$('[data-sb-acc]', root);
    accs.forEach(function (head) {
      head.addEventListener('click', function () {
        var isOpen = head.getAttribute('aria-expanded') === 'true';
        accs.forEach(function (h) {
          h.setAttribute('aria-expanded', 'false');
          h.querySelector('.sb-acc__sign').textContent = '+';
          h.nextElementSibling.hidden = true;
        });
        if (!isOpen) {
          head.setAttribute('aria-expanded', 'true');
          head.querySelector('.sb-acc__sign').textContent = '−';
          head.nextElementSibling.hidden = false;
        }
      });
    });

    var modal = $('[data-sb-modal]', root);
    var lastFocus = null;
    function closeModal() {
      if (!modal || modal.hidden) return;
      modal.hidden = true;
      var vid = $('[data-sb-modal-video]', modal);
      if (vid) { vid.pause(); vid.removeAttribute('src'); vid.load(); }
      if (lastFocus) lastFocus.focus();
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) { if (e.key === 'Escape') closeModal(); }
    $$('[data-sb-exp]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!modal) return;
        lastFocus = btn;
        $('[data-sb-modal-title]', modal).textContent = btn.getAttribute('data-title') || '';
        $('[data-sb-modal-text]', modal).textContent = btn.getAttribute('data-text') || '';
        var src = btn.getAttribute('data-video');
        var vid = $('[data-sb-modal-video]', modal);
        var empty = $('[data-sb-modal-empty]', modal);
        if (src) { vid.src = src; vid.hidden = false; empty.hidden = true; vid.play().catch(function () {}); }
        else { vid.hidden = true; empty.hidden = false; }
        modal.hidden = false;
        $('[data-sb-modal-close]', modal).focus();
        document.addEventListener('keydown', onKey);
      });
    });
    if (modal) {
      modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
      $('[data-sb-modal-close]', modal).addEventListener('click', closeModal);
    }
  }

  function initRelated(scope) {
    var rel = (scope || document).querySelector('[data-sb-related]');
    if (!rel || rel.dataset.sbBound) return;
    rel.dataset.sbBound = '1';

    var handle = rel.getAttribute('data-product-handle');
    var RECENT_KEY = 'silverbloom_recently_viewed';
    var recent = read(RECENT_KEY).filter(function (h) { return h !== handle; });
    var recentToShow = recent.slice(0, 8);
    recent.unshift(handle);
    write(RECENT_KEY, recent.slice(0, 8));

    function sized(src, w) {
      if (!src) return src;
      return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }
    function card(p) {
      var img = p.featured_image ? '<img src="' + sized(p.featured_image, 600) + '" alt="" loading="lazy">' : '<div class="sb-stripes"></div>';
      var variant = p.type || p.vendor || '';
      return '<a class="sb-rcard" href="/products/' + p.handle + '">' +
        '<div class="sb-rcard__media"><button type="button" class="sb-wish" data-sb-wish="' + p.handle + '" title="Ajouter à ma wishlist"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M12 20.5S4 15 4 9.5A4.5 4.5 0 0 1 12 6.7a4.5 4.5 0 0 1 8 2.8c0 5.5-8 11-8 11z"/></svg></button>' + img + '</div>' +
        '<span class="sb-rcard__name">' + p.title + '</span>' +
        (variant ? '<span class="sb-rcard__variant">' + variant + '</span>' : '') +
        '<span class="sb-rcard__price">' + fmt(p.price) + '</span></a>';
    }

    var reco = $('[data-sb-reco]', rel);
    if (reco) {
      var url = rel.getAttribute('data-reco-url') + '.js?product_id=' + rel.getAttribute('data-product-id') + '&limit=4';
      fetch(url).then(function (r) { return r.json(); }).then(function (d) {
        var prods = (d.products || []).slice(0, 4);
        reco.innerHTML = prods.map(card).join('');
        syncHearts();
      }).catch(function () {});
    }

    var recentWrap = $('[data-sb-recent]', rel);
    var recentEmpty = $('[data-sb-recent-empty]', rel);
    var recentLoaded = false;
    function loadRecent() {
      if (recentLoaded) return;
      recentLoaded = true;
      if (!recentToShow.length) { if (recentEmpty) recentEmpty.hidden = false; return; }
      Promise.all(recentToShow.slice(0, 4).map(function (h) {
        return fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).catch(function () { return null; });
      })).then(function (prods) {
        var ok = prods.filter(Boolean);
        if (!ok.length) { if (recentEmpty) recentEmpty.hidden = false; return; }
        recentWrap.innerHTML = ok.map(card).join('');
        syncHearts();
      });
    }

    $$('[data-sb-rtab]', rel).forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = tab.getAttribute('data-sb-rtab');
        $$('[data-sb-rtab]', rel).forEach(function (t) { t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false'); });
        tab.classList.add('is-active'); tab.setAttribute('aria-selected', 'true');
        $$('[data-sb-rpanel]', rel).forEach(function (p) { p.hidden = p.getAttribute('data-sb-rpanel') !== idx; });
        if (idx === '1') loadRecent();
      });
    });
  }

  function initMaison(scope) {
    var maison = (scope || document).querySelector('[data-sb-maison]');
    if (!maison || maison.dataset.sbBound) return;
    maison.dataset.sbBound = '1';
    $$('[data-sb-mtab]', maison).forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = tab.getAttribute('data-sb-mtab');
        $$('[data-sb-mtab]', maison).forEach(function (t) { t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false'); });
        tab.classList.add('is-active'); tab.setAttribute('aria-selected', 'true');
        $$('[data-sb-mpanel]', maison).forEach(function (p) { var on = p.getAttribute('data-sb-mpanel') === idx; p.hidden = !on; p.classList.toggle('is-active', on); });
        $$('[data-sb-mimg]', maison).forEach(function (im) { im.classList.toggle('is-active', im.getAttribute('data-sb-mimg') === idx); });
      });
    });
  }

  function initAll(scope) {
    initProduct(scope);
    initRelated(scope);
    initMaison(scope);
    syncHearts();
  }

  initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
